.head {
  margin: 4px 4px 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.intro {
  margin: 0 4px;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.4;
}

.wheelBox {
  position: relative;
  width: 290px;
  height: 290px;
  margin: 18px auto 10px;
}

.wheel {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 7px solid #1d1d1d;
  box-shadow:
    0 0 0 2px rgb(255 204 77 / 50%),
    0 10px 40px rgb(255 204 77 / 15%);
  box-sizing: border-box;
  will-change: transform;
}

.label {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 70px;
  margin: -9px 0 0 -35px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: #ffcc4d;
  transform-origin: 50% 50%;
}

.labelJackpot {
  color: #ff8fa3;
  font-size: 13px;
}

.pointer {
  position: absolute;
  left: 50%;
  top: -8px;
  z-index: 2;
  width: 0;
  height: 0;
  transform: translateX(-50%);
  border-left: 13px solid transparent;
  border-right: 13px solid transparent;
  border-top: 24px solid #ffcc4d;
}

.hub {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 3px solid #ffcc4d;
  background: var(--surface);
  font-size: 10px;
  letter-spacing: 0.1em;
  color: var(--ink-soft);
}

.error {
  margin: 0;
  font-size: 13px;
  color: var(--danger);
  text-align: center;
}

.discount {
  padding: 12px 14px;
  border-radius: var(--r-md);
  border: 1px solid rgb(255 204 77 / 35%);
  background: var(--warn-wash);
  font-size: 14px;
  color: var(--ink);
}

.section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
}

.sectionTitle {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
}

.muted {
  color: var(--muted);
}

.resultText {
  margin: 0 0 14px;
  font-size: 15px;
  line-height: 1.45;
  color: var(--ink-soft);
}
